export type ExperienceItem = {
  title: string;
  description: string;
};

export type TeamMember = {
  slug: string;
  name: string;
  title: string;
  photo: string;
  location: string;
  phone: string;
  email: string;
  sectors: string[];
  practices: string[];
  bio: string;
  previousExperience: ExperienceItem[];
  education: ExperienceItem[];
  admissions: ExperienceItem[];
};

export const teamMembers: TeamMember[] = [
  {
    slug: "paul-murimi",
    name: "Kiongo P. Murimi",
    title: "Managing Partner",
    photo: "/team1/murimi.jpg",
    location: "Nakuru",
    phone: "0721398373",
    email: "murimi@mmmnlaw.org | kiongopaulmurimi@gmail.com",
    sectors: ["Finance", "Technology"],
    practices: ["Corporate", "Tax"],
    bio: "Mr. Kiongo Paul Murimi is the Managing Partner of the firm and is in charge of general management of the firm including being the contact person of the firm to the clients and heads the Dispute Resolution and Insurance defence Litigation. Mr. Paul Murimi heads the General litigation department. He has vast experience in both civil, labour relations and employment, cases, land law, family law and criminal law litigation. His role as the head of litigation ensures that there is sufficient research, in house consultation pre-trial briefing before a matter proceeds for hearing. This ensures that any counsel handling any matter is well prepared and equipped to tackle the suit. Mr. Murimi is famed for having handled a myriad of industrial defence litigations in which emerging jurisprudence were developed and thus setting the benchmark for how industrial accident claims/ labor relations matters are defended ",
    previousExperience: [
      {
        title: "Managing Partner of the firm",
        description:
          "Mr. Kiongo Paul Murimi is the Managing Partner of the firm and is in charge of general management of the firm including being the contact person of the rm to the clients and heads the Dispute Resolution and Insurance defence Litigation. ",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws Moi University LL. B (HONS)",
        description: "Bachelor of Laws Moi University LL. B (HONS)",
      },
    ],
    admissions: [
      {
        title: "Admission to Roll of Advocates.",
        description: "He was admitted to the Roll of Advocates in June 2003.",
      },
    ],
  },
  {
    slug: "anderson-mbago",
    name: "Mbago A. Omondi",
    title: "Senior Partner",
    photo: "/team/mbago.jpg",
    location: "Mombasa",
    phone: "0721 647726",
    email: "mbago@mmmlaw.org | mbagoanderson05@yahoo.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Mbago Anderson heads the firm's Mombasa Branch on a full time basis. He is a famed litigator/negotiator who has managed to secure very attractive settlements especially in recovery claims for the insurance companies and in insurance defense matters. Mr. Mbago has the operational skills when defending fraudulent claims that are adversely affecting the expanding power industry. His interaction with over 60% of the power farms in Naivasha has equipped him with firsthand knowledge on the operations of corporate clients and as such he has over the years become an invaluable asset in representing corporate clients. Mr. Mbago has successfully handled marine related negotiations and litigation for both local and international clients.",
    previousExperience: [
      {
        title: "Partner in charge of the Mombasa Branch",
        description:
          "Mr. Mbago is currently the partner in charge of the Mombasa Branch.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws Moi University LL. B (HONS)",
        description: "Bachelor of Laws Moi University LL. B (HONS)",
      },
      
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates in April 2007",
        description: "Admitted to the Roll of Advocates in April 2007",
      },
    ],
  },
  {
    slug: "aston-muchela",
    name: "Muchela A. Ong'enge",
    title: "Senior Partner",
    photo: "/team1/muchela.jpg",
    location: "Nakuru",
    phone: "0723356135",
    email: "muchela@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Muchela heads the corporate and commercial practice department. He has been instrumental in company formations and advice on corporate affairs, tax and labour - related issues. He also heads the research and strategic development Department for the firm. Mr. Muchela is also instrumental in both civil and criminal litigation. He is famed for his prowess in defending suits especially the Labour Relations/Employment Cases. He conducts the due diligence in various transactions and is tasked with the carrying out of the necessary legal audits and compliance for corporate clients",
    previousExperience: [
      {
        title: "Certified Public Secretary (CPS)",
        description:
          "Certified Public Secretary (CPS)",
      },
      {
        title: "Certified Arbitrator",
        description:
          "Certified Public Secretary (CPS) ",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws Moi University LL. B (HONS)",
        description: "Bachelor of Laws Moi University LL. B (HONS)",
      },
    ],
    admissions: [
      {
        title: "Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in November 2007 ",
      },
    ],
  },
  {
    slug: "tymm-geno",
    name: "Chek Tymm Geno",
    title: "Senior Associate Partner",
    photo: "/team1/tymm.jpg",
    location: "Nakuru",
    phone: "0726404484",
    email: "geno@mnmmlaw.org | tymmsenior@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Geno has specialized in commercial corporate and Conveyancing work including perfection of securities, drafting and advising on contracts and property acquisition. He is also instrumental in the litigation team for corporate clients. Mr.Geno is also an astute litigator and has been instrumental in suppressing fraudulent claims against insurance companies. He has largely and successfully defended such claims arising in power farms in his stint as the in - charge of the Naivasha station matters. Mr Geno is equally instrumental in strategic growth of the rm and business development.",
    previousExperience: [
      {
        title: "Senior Associate Partner",
        description:
          "He was admitted as a Senior Associate Partner with the firm in the year 2022",
      },
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in March, 2016"
      }
    ],
    education: [
      {
        title: "Bachelor of Laws. Moi University",
        description: "Bachelor of Laws. Moi University",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in March, 2016"
      }
    ],
  },
  {
    slug: "abigail-chelule",
    name: "Abigail C. Chelule",
    title: "Associate Advocate",
    photo: "/team1/abigail.jpg",
    location: "Nakuru",
    phone: "0714588906",
    email: "abigail@mmmnlaw.org | abigailchelule@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Ms. Chelule is an avid draftsman when it comes to pleadings, contracts and legal opinions. She is also a certified mediator and keenly interested in alternative dispute resolution mechanisms much as she is also involved in litigation in various legal fields. She is currently based in our Nakuru office. ",
    previousExperience: [
      {
        title: "",
        description:
          "",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - MOI.",
        description: "Bachelor of Laws - MOI.",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "She was admitted to the Roll of Advocates in 2018",
      },
    ],
  },
  {
    slug: "danson-munyiri",
    name: "Danson N. Munyiri",
    title: "Associate Advocate",
    photo: "/team1/danson.jpg",
    location: "Nakuru",
    phone: " 0713378740",
    email: "danson@mmmnlaw.org, | ndungudanson98@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Munyiri is a seasoned litigator and draftsman when it comes to pleadings, contracts and legal opinions. He brings in a load of experience in handling public interest litigation as well. He is currently based in our Nakuru office.",
    previousExperience: [
      {
        title: "Seasoned Litigator and draftsman",
        description: "Mr. Munyiri is a seasoned litigator and draftsman when it comes to pleadings, contracts and legal opinions.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - UON",
        description: "Bachelor of Laws - UON",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2020.",
      },
    ],
  },
  {
    slug: "philip mwenda",
    name: "Philip M. Mwenda",
    title: "Advocate",
    photo: "/team1/Phil1.jpg",
    location: "Nakuru",
    phone: "0714588906",
    email: "philip@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Quisque quis tortor vel ligula molestie bibendum sed non metus. Pellentesque tempor, ipsum et convallis mattis, tortor erat viverra neque, vel tincidunt nunc dolor nec turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse suscipit viverra gravida. Ut id risus lacinia, facilisis ligula faucibus, fringilla nisi. Aliquam justo lectus, consectetur id porta non, commodo sit amet lectus. Nullam rutrum lacinia magna eu pharetra.",
    previousExperience: [
      {
        title: "Senior Associate, Global Law LLP",
        description:
          "Quisque quis tortor vel ligula molestie bibendum sed non metus. Pellentesque tempor, ipsum et convallis mattis, tortor erat viverra neque, vel tincidunt nunc dolor nec turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse suscipit viverra gravida. Ut id risus lacinia, facilisis ligula faucibus, fringilla nisi. Aliquam justo lectus, consectetur id porta non, commodo sit amet lectus. Nullam rutrum lacinia magna eu pharetra.",
      },
    ],
    education: [
      {
        title: "LL.M, Harvard Law School",
        description: "Quisque quis tortor vel ligula molestie bibendum sed non metus. Pellentesque tempor, ipsum et convallis mattis, tortor erat viverra neque, vel tincidunt nunc dolor nec turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse suscipit viverra gravida. Ut id risus lacinia, facilisis ligula faucibus, fringilla nisi. Aliquam justo lectus, consectetur id porta non, commodo sit amet lectus. Nullam rutrum lacinia magna eu pharetra.",
      },
      {
        title: "LL.B, University of Oxford",
        description: "Quisque quis tortor vel ligula molestie bibendum sed non metus. Pellentesque tempor, ipsum et convallis mattis, tortor erat viverra neque, vel tincidunt nunc dolor nec turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse suscipit viverra gravida. Ut id risus lacinia, facilisis ligula faucibus, fringilla nisi. Aliquam justo lectus, consectetur id porta non, commodo sit amet lectus. Nullam rutrum lacinia magna eu pharetra.",
      },
    ],
    admissions: [
      {
        title: "Solicitor, England & Wales",
        description: "Quisque quis tortor vel ligula molestie bibendum sed non metus. Pellentesque tempor, ipsum et convallis mattis, tortor erat viverra neque, vel tincidunt nunc dolor nec turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse suscipit viverra gravida. Ut id risus lacinia, facilisis ligula faucibus, fringilla nisi. Aliquam justo lectus, consectetur id porta non, commodo sit amet lectus. Nullam rutrum lacinia magna eu pharetra.",
      },
    ],
  },
  {
    slug: "brenda",
    name: "Brenda",
    title: "Advocate",
    photo: "/team1/Brenda4.jpg",
    location: "Nakuru",
    phone: "0720096982",
    email: "quintera55@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Ms. Quinter is a seasoned litigator and skilled negotiator, renowned for her considerable success in securing the interests of clients both in and out of court. Her expertise in handling complex claims and her adept negotiation skills contribute significantly to achieving favorable outcomes for her clients. She is currently based in our Mombasa office.",
    previousExperience: [
      {
        title: "Seasoned litigator and skilled negotiator",
        description:
          "Ms. Quinter is a seasoned litigator and skilled negotiator, renowned for her considerable success in securing the interests of clients both in and out of court.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - Mount Kenya University",
        description: "Bachelor of Laws - Mount Kenya University",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "She was admitted to the Roll of Advocates in 2022.",
      },
    ],
  },
  {
    slug: "askah-kerubo",
    name: "Askah Kerubo",
    title: "Advocate",
    photo: "/team1/askah.jpg",
    location: "Nakuru",
    phone: "0702701209",
    email: "askahkerubo@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Mbithi’s extensive experience in public interest litigation underscores his commitment to addressing significant legal and social issues, reflecting his passion for impactful advocacy. His approach combines a rigorous legal acumen with a genuine commitment to justice, making him a valuable asset in both individual and public interest cases. He is currently based in our Mombasa office",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "Mr. Mbithi’s extensive experience in public interest litigation underscores his commitment to addressing significant legal and social issues, reflecting his passion for impactful advocacy.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - UON",
        description: "Bachelor of Laws - UON",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
  {
    slug: "Ivy",
    name: "Ivy",
    title: "Advocate",
    photo: "/team1/Ivy1.jpg",
    location: "Nakuru",
    phone: "0727800417",
    email: "tonyanampiu@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice. His experience in public interest litigation highlights a commitment to addressing signicant legal and social issues. He is currently based in our Mombasa ofce.",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - CUEA",
        description: "Bachelor of Laws - CUEA",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
  {
    slug: "guyo-alkano",
    name: "Guyo Alkano Golicha",
    title: "Advocate",
    photo: "/team1/Guyo1.jpg",
    location: "Nakuru",
    phone: "0718097912",
    email: "guyoalkano34@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "Mr. Guyo is an avid litigator and adept draftsman, excelling in the preparation of pleadings, contracts, and legal opinions. His extensive experience in handling public interest litigation highlights his dedication to addressing important legal and social issues. Mr. Guyo’s expertise and commitment make him a key advocate in both individual and community-focused legal matters. He is currently based in our Nakuru office.",
    previousExperience: [
      {
        title: "Litigation and drafting",
        description: "Mr. Guyo is an avid litigator and adept draftsman, excelling in the preparation of pleadings, contracts, and legal opinions.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - UON",
        description: "Bachelor of Laws - UON",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023",
      },
    ],
  },
  {
    slug: "kennedy-ngesa",
    name: "Kennedy Ngesa",
    title: "Litigation & Conveyancing Clerk",
    photo: "/team1/kennedy.jpg",
    location: "Nakuru",
    phone: "",
    email: "",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "",
    previousExperience: [
      {
        title: "Litigation and conveyancing clerk",
        description:
          "",
      },
    ],
    education: [
      {
        title: "",
        description: "",
      },
    ],
    admissions: [
      {
        title: "",
        description: "",
      },
    ],
  },
  {
    slug: "vivian-njenga",
    name: "Vivian Njenga",
    title: "Registry Administrator",
    photo: "/team1/vivian.jpg",
    location: "Nakuru",
    phone: "",
    email: "vivian@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "",
    previousExperience: [
      {
        title: "",
        description: "",
      },
    ],
    education: [
      {
        title: "",
        description: "",
      },
    ],
    admissions: [
      {
        title: "",
        description: "",
      },
    ],
  },
  {
    slug: "Vivian",
    name: "Vivian",
    title: "Secretary",
    photo: "/team1/Vivian2.jpg",
    location: "Nakuru",
    phone: "0714588906",
    email: "elizabeth@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "",
    previousExperience: [
      {
        title: "",
        description: "",
      },
    ],
    education: [
      {
        title: "",
        description: "",
      },
    ],
    admissions: [
      {
        title: "",
        description: "",
      },
    ],
  },
  {
    slug: "jacinta-mugane",
    name: "Jacinta Mugane",
    title: "Receptionist",
    photo: "/team1/jacinta.jpg",
    location: "Nakuru",
    phone: "0714588906",
    email: "jacinta@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "",
    previousExperience: [
      {
        title: "",
        description: "",
      },
    ],
    education: [
      {
        title: "",
        description: "",
      },
    ],
    admissions: [
      {
        title: "",
        description: "",
      },
    ],
  },
  {
    slug: "edwin-kirago",
    name: "Edwin Kirago",
    title: "Para Legal",
    photo: "/team1/Edwin1.jpg",
    location: "Nakuru",
    phone: "0714588906",
    email: "edwin@mmmnlaw.org",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "",
    previousExperience: [
      {
        title: "",
        description: "",
      },
    ],
    education: [
      {
        title: "",
        description: "",
      },
    ],
    admissions: [
      {
        title: "",
        description: "",
      },
    ],
  },
  {
    slug: "mafrine-atieno",
    name: "Mafrine Atieno",
    title: "Advocate",
    photo: "/team1/mafrine.jpg",
    location: "Nakuru",
    phone: "0727800417",
    email: "tonyanampiu@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice. His experience in public interest litigation highlights a commitment to addressing signicant legal and social issues. He is currently based in our Mombasa ofce.",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - CUEA",
        description: "Bachelor of Laws - CUEA",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
  {
    slug: "Brenda",
    name: "Brenda",
    title: "Advocate",
    photo: "/team1/brenda.jpg",
    location: "Nakuru",
    phone: "0727800417",
    email: "tonyanampiu@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice. His experience in public interest litigation highlights a commitment to addressing signicant legal and social issues. He is currently based in our Mombasa ofce.",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - CUEA",
        description: "Bachelor of Laws - CUEA",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
  {
    slug: "danson",
    name: "Danson",
    title: "Advocate",
    photo: "/team1/danson.jpg",
    location: "Nakuru",
    phone: "0727800417",
    email: "tonyanampiu@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice. His experience in public interest litigation highlights a commitment to addressing signicant legal and social issues. He is currently based in our Mombasa ofce.",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - CUEA",
        description: "Bachelor of Laws - CUEA",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
  {
    slug: "eric",
    name: "Eric",
    title: "Advocate",
    photo: "/team1/Eric1.jpg",
    location: "Nakuru",
    phone: "0727800417",
    email: "tonyanampiu@gmail.com",
    sectors: ["Energy", "Healthcare"],
    practices: ["Litigation"],
    bio: "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice. His experience in public interest litigation highlights a commitment to addressing signicant legal and social issues. He is currently based in our Mombasa ofce.",
    previousExperience: [
      {
        title: "Public interest litigation",
        description:
          "With a proven track record in both litigation and drafting, Mr. Kirimi leverages a deep understanding of legal principles and a dedication to justice in every aspect of their practice.",
      },
    ],
    education: [
      {
        title: "Bachelor of Laws - CUEA",
        description: "Bachelor of Laws - CUEA",
      },
    ],
    admissions: [
      {
        title: "Admitted to the Roll of Advocates",
        description: "He was admitted to the Roll of Advocates in 2023.",
      },
    ],
  },
];
